<template>
  <div>
    <a-form :form="form" @submit="handleSearch">
      <a-row :gutter="24">
        <a-col :span="20" :xxl="6">
          <a-form-item>
            <a-input
              v-decorator="['name', {
                normalize: this.$lodash.trim
              }]"
              placeholder="请输入产品名称"
              allow-clear
            />
          </a-form-item>
        </a-col>

        <a-col :span="4" :xxl="6">
          <a-form-item>
            <a-space class="search-btn">
              <a-button type="primary" html-type="submit">
                搜索
              </a-button>
              <a-button @click="handleReset">
                刷新
              </a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>
<script>
export default {
  name: 'SearchProduct',
  data() {
    return {
      form: this.$form.createForm(this, { name: 'product_search' })
    }
  },
  methods: {
    handleSearch(e) {
      e.preventDefault()
      this.$emit('submit', this.form.getFieldsValue())
    },

    handleReset() {
      this.form.resetFields()
      this.$emit('submit', {})
    }
  }
}
</script>

<style lang="less" scoped>
.search-btn {
  display: flex;
  justify-content: space-evenly;
}
</style>

